/*
#FFFDF8
#F0FDF1
#DCFCE0
#BBF7C2
#85F094
#49DF5E
#22CE3A
#15A429
#148124
#156621
#14531F
#052E0D
*/

export const jade = {
  jade0: `#FFFDF8`, // 255, 253, 248
  jade1: `#F0FDF1`, // 240, 253, 241
  jade2: `#DCFCE0`, // 220, 252, 224
  jade3: `#BBF7C2`, // 187, 247, 194
  jade4: `#85F094`, // 133, 240, 148
  jade5: `#49DF5E`, // 73, 223, 94
  jade6: `#22CE3A`, // 34, 206, 58 *
  jade7: `#15A429`, // 21, 164, 41
  jade8: `#148124`, // 20, 129, 36
  jade9: `#156621`, // 21, 102, 33
  jade10: `#14531F`, // 20, 83, 31
  jade11: `#052E0D`, // 5, 46, 13
  jade12: `#052E0D`, // 5, 46, 13
} as const;

export const jadeDark = {
  jade0: `#185f26`,
  jade1: `#1e6e2e`,
  jade2: `#257d37`,
  jade3: `#2b8a3e`,
  jade4: `#2f9e44`,
  jade5: `#37b24d`,
  jade6: `#40c057`,
  jade7: `#51cf66`,
  jade8: `#69db7c`,
  jade9: `#8ce99a`,
  jade10: `#b2f2bb`,
  jade11: `#d3f9d8`,
  jade12: `#ebfbee`,
} as const;

/**
 *
 *
 *
 * Archives.
 *
 * jade0: `#ebfbee`,
 * jade1: `#d3f9d8`,
 * jade2: `#b2f2bb`,
 * jade3: `#8ce99a`,
 * jade4: `#69db7c`,
 * jade5: `#51cf66`,
 * jade6: `#40c057`,
 * jade7: `#37b24d`,
 * jade8: `#2f9e44`,
 * jade9: `#2b8a3e`,
 * jade10: `#257d37`,
 * jade11: `#1e6e2e`,
 * jade12: `#185f26`,
 */
